export default __webpack_public_path__ + "static/media/wShoes_1_c2.9f5ae3b9.jpeg";